module.exports = __webpack_public_path__ + "media/scripts/pages/join/assets/media/benefits/monetisation-ccc1fb0de6e02417854b1347e33d8808.svg";